// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* View Toggle */
.view-toggle {
    display: flex;
    gap: 8px;
    margin-bottom: 20px;
    justify-content: flex-end;
}

.view-toggle-btn {
    padding: 8px 12px;
    border: 1px solid #ddd;
    background: white;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.view-toggle-btn:hover {
    background: #f5f5f5;
    border-color: #bbb;
}

.view-toggle-btn.active {
    background: #007bff;
    border-color: #007bff;
    color: white;
}

.view-toggle-btn svg {
    display: block;
}

/* Card View */
.scanner-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
    gap: 16px;
}

/* Table View */
.scanner-table-wrapper {
    background: white;
    border-radius: 10px;
    overflow-x: auto;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.scanner-table {
    width: 100%;
    border-collapse: collapse;
}

.scanner-table thead {
    background: #f8f9fa;
    border-bottom: 2px solid #dee2e6;
}

.scanner-table th {
    padding: 12px 16px;
    text-align: left;
    font-weight: 600;
    color: #495057;
    font-size: 14px;
}

.scanner-table tbody tr {
    border-bottom: 1px solid #dee2e6;
    transition: background-color 0.2s;
}

.scanner-table tbody tr:hover {
    background-color: #f8f9fa;
}

.scanner-table tbody tr:last-child {
    border-bottom: none;
}

.scanner-table td {
    padding: 12px 16px;
    font-size: 14px;
    color: #495057;
}

.scanner-name-cell {
    min-width: 180px;
}

.serial-cell {
    font-family: monospace;
    font-size: 13px;
    color: #6c757d;
}

.actions-cell {
    white-space: nowrap;
}

.actions-cell button {
    margin-right: 8px;
}

.btn-small {
    padding: 6px 12px;
    font-size: 13px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
    font-weight: 500;
}

.btn-primary {
    background: #007bff;
    color: white;
}

.btn-primary:hover {
    background: #0056b3;
}

.btn-success {
    background: #28a745;
    color: white;
}

.btn-success:hover {
    background: #218838;
}

.btn-danger {
    background: #dc3545;
    color: white;
}

.btn-danger:hover {
    background: #c82333;
}

.status-badge {
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    display: inline-block;
}

.status-connected {
    background: #d4edda;
    color: #155724;
}

.status-disconnected {
    background: #f8d7da;
    color: #721c24;
}

/* Empty State */
.empty-state {
    text-align: center;
    padding: 60px 20px;
    background: white;
    border-radius: 10px;
    color: #666;
}

.empty-state p {
    font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ScannerList.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA,cAAc;AACd;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA,eAAe;AACf;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB","sourcesContent":["/* View Toggle */\n.view-toggle {\n    display: flex;\n    gap: 8px;\n    margin-bottom: 20px;\n    justify-content: flex-end;\n}\n\n.view-toggle-btn {\n    padding: 8px 12px;\n    border: 1px solid #ddd;\n    background: white;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.view-toggle-btn:hover {\n    background: #f5f5f5;\n    border-color: #bbb;\n}\n\n.view-toggle-btn.active {\n    background: #007bff;\n    border-color: #007bff;\n    color: white;\n}\n\n.view-toggle-btn svg {\n    display: block;\n}\n\n/* Card View */\n.scanner-list {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));\n    gap: 16px;\n}\n\n/* Table View */\n.scanner-table-wrapper {\n    background: white;\n    border-radius: 10px;\n    overflow-x: auto;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.scanner-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.scanner-table thead {\n    background: #f8f9fa;\n    border-bottom: 2px solid #dee2e6;\n}\n\n.scanner-table th {\n    padding: 12px 16px;\n    text-align: left;\n    font-weight: 600;\n    color: #495057;\n    font-size: 14px;\n}\n\n.scanner-table tbody tr {\n    border-bottom: 1px solid #dee2e6;\n    transition: background-color 0.2s;\n}\n\n.scanner-table tbody tr:hover {\n    background-color: #f8f9fa;\n}\n\n.scanner-table tbody tr:last-child {\n    border-bottom: none;\n}\n\n.scanner-table td {\n    padding: 12px 16px;\n    font-size: 14px;\n    color: #495057;\n}\n\n.scanner-name-cell {\n    min-width: 180px;\n}\n\n.serial-cell {\n    font-family: monospace;\n    font-size: 13px;\n    color: #6c757d;\n}\n\n.actions-cell {\n    white-space: nowrap;\n}\n\n.actions-cell button {\n    margin-right: 8px;\n}\n\n.btn-small {\n    padding: 6px 12px;\n    font-size: 13px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: all 0.2s;\n    font-weight: 500;\n}\n\n.btn-primary {\n    background: #007bff;\n    color: white;\n}\n\n.btn-primary:hover {\n    background: #0056b3;\n}\n\n.btn-success {\n    background: #28a745;\n    color: white;\n}\n\n.btn-success:hover {\n    background: #218838;\n}\n\n.btn-danger {\n    background: #dc3545;\n    color: white;\n}\n\n.btn-danger:hover {\n    background: #c82333;\n}\n\n.status-badge {\n    padding: 4px 10px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 500;\n    display: inline-block;\n}\n\n.status-connected {\n    background: #d4edda;\n    color: #155724;\n}\n\n.status-disconnected {\n    background: #f8d7da;\n    color: #721c24;\n}\n\n/* Empty State */\n.empty-state {\n    text-align: center;\n    padding: 60px 20px;\n    background: white;\n    border-radius: 10px;\n    color: #666;\n}\n\n.empty-state p {\n    font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
